import taskInstancesViewRowUrl from './taskInstancesViewRow.html';

class TaskInstancesViewRowCtrl {
  constructor($uibModal) {
    'ngInject';

    Object.assign(this, { $uibModal });
  }

  viewTask(taskInstance) {
    const self = this;

    const previewModalPromise = this.$uibModal
      .open({
        template:
          '<view-task-instance modal="modal" task-instance="selectedTaskInstance" is-preview="true" parent-modal="parentModal"></view-task-instance>',
        size: '620',
        controller: function TaskInstanceViewOrEditStateCtrl($scope, $uibModalInstance) {
          'ngInject';

          $scope.modal = $uibModalInstance;
          $scope.parentModal = self.parentModal;
          $scope.selectedTaskInstance = $scope.$resolve.selectedTaskInstance;
        },
        resolve: {
          selectedTaskInstance: () => taskInstance,
        },
      })
      .result.ignoreCancel();
    this.onTaskPreview({ previewModalPromise });
  }
}

export default {
  templateUrl: taskInstancesViewRowUrl,
  controller: TaskInstancesViewRowCtrl,
  controllerAs: 'ctrl',
  bindings: {
    taskInstances: '<',
    onTaskPreview: '&?',
    parentModal: '<?',
  },
};
